import { render, staticRenderFns } from "./FiltroRelatorio.vue?vue&type=template&id=1908b33c&scoped=true"
import script from "./FiltroRelatorio.vue?vue&type=script&lang=js"
export * from "./FiltroRelatorio.vue?vue&type=script&lang=js"
import style0 from "./FiltroRelatorio.vue?vue&type=style&index=0&id=1908b33c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1908b33c",
  null
  
)

export default component.exports